import React, { createContext } from 'react';

export const PartidosContext = createContext();